import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RedemptionsRoutingModule } from './redemptions-routing.module';
import { RedemptionsComponent } from './redemptions/redemptions.component';
import { RedemptionDetailsComponent } from './redemption-details/redemption-details.component';
import {NgxSpinnerModule} from "ngx-spinner";
import {SharedModule} from "@shared/shared.module";
import {PopoverModule} from "ngx-bootstrap/popover";
import {FormsModule} from "@angular/forms";
import {QRCodeModule} from "angularx-qrcode";


@NgModule({
  declarations: [
    RedemptionsComponent,
    RedemptionDetailsComponent
  ],
  imports: [
    CommonModule,
    RedemptionsRoutingModule,
    NgxSpinnerModule,
    SharedModule,
    PopoverModule,
    FormsModule,
    QRCodeModule,
  ]
})
export class RedemptionsModule { }
